/**
 * @flow
 * @relayHash 2a5aa1a73cdf76ca1eddec600b667699
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CommentsList_commenting$ref = any;
type CommonNameItem_commonName$ref = any;
type CommonNamesDialog__commonNames$ref = any;
type TaxoClimb_lifeNode$ref = any;
export type PlantDescriptionQueryVariables = {|
  plantID: number
|};
export type PlantDescriptionQueryResponse = {|
  +plant: ?{|
    +id: string,
    +idInt: ?number,
    +description: ?string,
    +myPerms: ?$ReadOnlyArray<?string>,
    +commonNames: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +$fragmentRefs: CommonNameItem_commonName$ref,
        |}
      |}>
    |},
    +commonNamesStats: ?{|
      +totalCount: ?number
    |},
    +commenting: ?{|
      +$fragmentRefs: CommentsList_commenting$ref
    |},
    +$fragmentRefs: TaxoClimb_lifeNode$ref & CommonNamesDialog__commonNames$ref,
  |}
|};
export type PlantDescriptionQuery = {|
  variables: PlantDescriptionQueryVariables,
  response: PlantDescriptionQueryResponse,
|};
*/


/*
query PlantDescriptionQuery(
  $plantID: Int!
) {
  plant: lifeNodeByIntID(documentId: $plantID) {
    id
    idInt
    description
    myPerms
    ...TaxoClimb_lifeNode
    commonNames(first: 5, order: "-avg", language: "por") {
      edges {
        node {
          id
          ...CommonNameItem_commonName
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    commonNamesStats: commonNames {
      totalCount
    }
    ...CommonNamesDialog__commonNames
    commenting {
      ...CommentsList_commenting
      id
    }
  }
}

fragment TaxoClimb_lifeNode on LifeNode {
  children(first: 30) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        rankDisplay
        ...PlantLink_plant
        __typename
      }
      cursor
    }
  }
}

fragment CommonNameItem_commonName on CommonName {
  id
  name
  language
  voting {
    ...VotingButtons_voting
    id
  }
}

fragment CommonNamesDialog__commonNames on LifeNode {
  id
  myPerms
  allCommonNames: commonNames {
    edges {
      node {
        id
        ...CommonNameItem_commonName
      }
    }
  }
  commonNamesStats: commonNames {
    totalCount
  }
}

fragment CommentsList_commenting on Commenting {
  id
  comments(first: 30) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        ...CommentsItem_comment
        __typename
      }
      cursor
    }
  }
}

fragment CommentsItem_comment on Comment {
  id
  myPerms
  body
  document {
    revisionsCount
    id
  }
  revisionCreated {
    createdAt
    author {
      id
      username
      avatar(width: 40, height: 40) {
        url
      }
      ...ProfileLink_user
    }
    id
  }
  voting {
    ...VotingButtons_voting
    id
  }
  commenting {
    id
    count
  }
}

fragment ProfileLink_user on User {
  id
  username
  firstName
  reputation
  avatar(width: 40, height: 40) {
    url
  }
}

fragment VotingButtons_voting on Voting {
  id
  countUps
  countDowns
  sumValues
  mine {
    id
    value
  }
}

fragment PlantLink_plant on LifeNode {
  id
  idInt
  title
  slug
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "plantID",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "documentId",
    "variableName": "plantID"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "idInt",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "myPerms",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "language",
  "value": "por"
},
v7 = {
  "kind": "Literal",
  "name": "order",
  "value": "-avg"
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v11 = {
  "kind": "LinkedField",
  "alias": "commonNamesStats",
  "name": "commonNames",
  "storageKey": null,
  "args": null,
  "concreteType": "CommonNameConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  (v6/*: any*/),
  (v7/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "language",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "voting",
  "storageKey": null,
  "args": null,
  "concreteType": "Voting",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "countUps",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "countDowns",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sumValues",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mine",
      "storageKey": null,
      "args": null,
      "concreteType": "Vote",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PlantDescriptionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "plant",
        "name": "lifeNodeByIntID",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "LifeNode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "commonNames",
            "name": "__lifeNode__commonNames_connection",
            "storageKey": "__lifeNode__commonNames_connection(language:\"por\",order:\"-avg\")",
            "args": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "concreteType": "CommonNameConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CommonNameEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommonName",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "CommonNameItem_commonName",
                        "args": null
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "commenting",
            "storageKey": null,
            "args": null,
            "concreteType": "Commenting",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "CommentsList_commenting",
                "args": null
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "TaxoClimb_lifeNode",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "CommonNamesDialog__commonNames",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PlantDescriptionQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "plant",
        "name": "lifeNodeByIntID",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "LifeNode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "children",
            "storageKey": "children(first:30)",
            "args": (v12/*: any*/),
            "concreteType": "LifeNodeConnection",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "LifeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LifeNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "rankDisplay",
                        "args": null,
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ]
                  },
                  (v9/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "children",
            "args": (v12/*: any*/),
            "handle": "connection",
            "key": "ListLifeNode_children",
            "filters": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "commonNames",
            "storageKey": "commonNames(first:5,language:\"por\",order:\"-avg\")",
            "args": (v13/*: any*/),
            "concreteType": "CommonNameConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CommonNameEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommonName",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "commonNames",
            "args": (v13/*: any*/),
            "handle": "connection",
            "key": "lifeNode__commonNames",
            "filters": [
              "order",
              "language"
            ]
          },
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "allCommonNames",
            "name": "commonNames",
            "storageKey": null,
            "args": null,
            "concreteType": "CommonNameConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CommonNameEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommonName",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "commenting",
            "storageKey": null,
            "args": null,
            "concreteType": "Commenting",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "comments",
                "storageKey": "comments(first:30)",
                "args": (v12/*: any*/),
                "concreteType": "CommentConnection",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Comment",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "body",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "document",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Document",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "revisionsCount",
                                "args": null,
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "revisionCreated",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Revision",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "createdAt",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "author",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "User",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "username",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "avatar",
                                    "storageKey": "avatar(height:40,width:40)",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "height",
                                        "value": 40
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "width",
                                        "value": 40
                                      }
                                    ],
                                    "concreteType": "File",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "url",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "reputation",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          },
                          (v16/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "commenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Commenting",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "count",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "comments",
                "args": (v12/*: any*/),
                "handle": "connection",
                "key": "CommentsList_comments",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PlantDescriptionQuery",
    "id": null,
    "text": "query PlantDescriptionQuery(\n  $plantID: Int!\n) {\n  plant: lifeNodeByIntID(documentId: $plantID) {\n    id\n    idInt\n    description\n    myPerms\n    ...TaxoClimb_lifeNode\n    commonNames(first: 5, order: \"-avg\", language: \"por\") {\n      edges {\n        node {\n          id\n          ...CommonNameItem_commonName\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    commonNamesStats: commonNames {\n      totalCount\n    }\n    ...CommonNamesDialog__commonNames\n    commenting {\n      ...CommentsList_commenting\n      id\n    }\n  }\n}\n\nfragment TaxoClimb_lifeNode on LifeNode {\n  children(first: 30) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        rankDisplay\n        ...PlantLink_plant\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment CommonNameItem_commonName on CommonName {\n  id\n  name\n  language\n  voting {\n    ...VotingButtons_voting\n    id\n  }\n}\n\nfragment CommonNamesDialog__commonNames on LifeNode {\n  id\n  myPerms\n  allCommonNames: commonNames {\n    edges {\n      node {\n        id\n        ...CommonNameItem_commonName\n      }\n    }\n  }\n  commonNamesStats: commonNames {\n    totalCount\n  }\n}\n\nfragment CommentsList_commenting on Commenting {\n  id\n  comments(first: 30) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        ...CommentsItem_comment\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment CommentsItem_comment on Comment {\n  id\n  myPerms\n  body\n  document {\n    revisionsCount\n    id\n  }\n  revisionCreated {\n    createdAt\n    author {\n      id\n      username\n      avatar(width: 40, height: 40) {\n        url\n      }\n      ...ProfileLink_user\n    }\n    id\n  }\n  voting {\n    ...VotingButtons_voting\n    id\n  }\n  commenting {\n    id\n    count\n  }\n}\n\nfragment ProfileLink_user on User {\n  id\n  username\n  firstName\n  reputation\n  avatar(width: 40, height: 40) {\n    url\n  }\n}\n\nfragment VotingButtons_voting on Voting {\n  id\n  countUps\n  countDowns\n  sumValues\n  mine {\n    id\n    value\n  }\n}\n\nfragment PlantLink_plant on LifeNode {\n  id\n  idInt\n  title\n  slug\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "plant",
            "commonNames"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '17edef7496786a85cff2dcd743987248';
module.exports = node;
